<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Token de la conexión" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<div class="card border-0 shadow-none">
				<div class="card-body vstack gap-8 px-0 vstack gap-5">
					<template v-if="status == 'loading'">
						<CommonMessageInfo info="Comprobando estado..." />
					</template>
					<template v-else-if="status == 'exists'">
						<CommonMessageInfo info="El token ya existe, puede crear uno nuevo." />
					</template>
					<template v-else-if="status == 'creating'">
						<CommonMessageInfo info="Creando token..." />
					</template>
					<template v-else-if="status == 'created'">
						<CommonFormInputReadonly v-model="target.token_type" title="Tipo de token" />
						<CommonFormInputReadonly v-model="target.access_token" title="Access token" />
					</template>
				</div>
				<div class="card-footer hstack gap-3 px-0 pb-12 border-0 justify-content-end">
					<router-link :to="{ name: 'company.admin.synchronizer.index' }" class="btn btn-neutral rounded-pill">Cancelar</router-link>
					<button type="button" class="btn btn-primary rounded-pill" :disabled="submitting" @click="tokenCreate" v-if="status == 'exists'"><i class="bi bi-arrow-clockwise pe-2"></i>Refrescar</button>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import { ref, reactive, onBeforeMount } from 'vue';
	import router from '@/router';
	import _ from 'lodash';
	import moment from 'moment';
	import useVuelidate from '@vuelidate/core';
	import composableForm from '@/composables/form';
	import CompanyAdminSynchronizerRepository from '@/repositories/modules/Company/Admin/Synchronizer';

	export default {
		props: {
			id: String
		},
		setup(props) {
			const { submitting, catchError } = composableForm();
			const status = ref('loading');

			const target = reactive({
				token_type: null,
				access_token: null
			});

			onBeforeMount(async () => {
				await CompanyAdminSynchronizerRepository.tokenCheck(props.id).then((response) => {
					status.value = response.data.status;
					if(status.value == 'creating') tokenCreate();
				}).catch((e) => {
					catchError(e);
					router.push({ name: `company.admin.synchronizer.index` });
				});
			});

			const tokenCreate = async () => {
				status.value = 'creating';

				await CompanyAdminSynchronizerRepository.tokenCreate(props.id).then((response) => {
					Object.assign(target, response.data);
					status.value = 'created';
				}).catch((e) => {
					catchError(e);
					router.push({ name: `company.admin.synchronizer.index` });
				});
			}

			return { submitting, target, status, tokenCreate };
		}
	}
</script>